import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../../components/Layout'
import ServiceFooter from '../../components/ServiceFooter'

import { operationServiceItems } from '../../serviceCategories'
import ServiceMenuItem from '../../components/ServiceMenuItem'

const Remote = () => {
  const {
    site: {
      siteMetadata: { title },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <Layout>
      <Helmet>
        <html className="temp" lang="ja" />
        <title>{`オペレーション | ${title}`}</title>
        <meta
          name="description"
          content="アイテックはコールセンター、機器メンテナンス、未清算出庫管理などを業界最高水準で提供します。"
        />
      </Helmet>

      <div className="common-header clearfix">
        <p className="category pc-only">製品・サービス</p>
        <h1>オペレーション</h1>
        <p className="category sp-only">製品・サービス</p>

        <div className="breadcrumb">
          <li>
            <Link to={`/`}>トップページ</Link>
          </li>
          /
          <li>
            <Link to={`/service`}>製品・サービス</Link>
          </li>
          /<li>オペレーション</li>
        </div>
      </div>

      <div className="main-wrapper middle-toppage operation">
        <div className="row">
          <div className="container empty"></div>
        </div>

        <div className="row">
          <div className="h-wrapper">
            <h2>アイテックのオペレーション</h2>
          </div>
        </div>

        <div className="row">
          <div className="container top">
            <h4>
              コールセンター、機器メンテナンス、未精算出庫管理などを業界最高水準で提供
            </h4>

            <p>
              駐車場機器専業メーカーとしての約30年の現場ノウハウと実績、テクノロジーを活かして、高い応答率を誇るコールセンターから全国規模で原則24時間以内の復旧が可能なメンテナンス、未精算出庫対応まで、万全の運営体制の構築を支援します。
            </p>

            <h5>頼れるパートナーとして一気通貫で伴走が可能</h5>

            <img
              className="big-picture pc-only"
              src="/img/step-itc-with-corp.svg"
              alt="運営会社様とアイテックの、事前相談から運営にかけての伴走"
            />
            <div className="center">
              <img
                className="middle-picture sp-only"
                src="/img/step-itc-with-corp-sp.svg"
                alt="運営会社様とアイテックの、事前相談から運営にかけての伴走"
              />
            </div>
          </div>
        </div>

        <div class="row bottom">
          <div className="container top">
            <h5>関連ページ</h5>
            <div className="service-mega__items">
              {operationServiceItems?.map((item) => (
                <ServiceMenuItem
                  key={`operation-${item.to || item.href || 'noop'}`}
                  item={item}
                />
              ))}
            </div>
          </div>
        </div>

        <ServiceFooter />
      </div>
    </Layout>
  )
}

export default Remote
